<template>
  <div id="app">


    <!-- <div class="show-builder-menu" v-if="isShow">
      <span @click="handleToPage('protac')">Home</span>
      <span @click="handleToPage('about')">About Us</span>
      <span @click="handleToPage('testimonial')">Protac Design Platform</span>
      <span @click="handleToPage('contact')" style="border:none">Contact Us</span>
    </div> -->
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
    }
  },
  created: function () {

  },
  computed: {


  },
  methods: {
    handleToPage(url) {
      console.log(url)
      this.$router.push({ name: url })
      this.isShow = false
    },
    handleShowMenu() {
      this.isShow = true
    },
    handleCloseMenu() {
      this.isShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 920px) {
  .show-builder-menu {
    position: fixed;
    top: 75px;
    left: 0;
    width: 100%;
    z-index: 99;
    background-color: #f7fdfb;
    display: flex;
    flex-direction: column;

    span {
      line-height: 40px;
      padding: 0 20px;
      border-bottom: 1px solid #d5dbd9;
    }

    span:active {
      color: #fff;
      font-weight: bold;
    }
  }

  .ast-desktop-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .site-header-primary-section-left {
      padding-left: 10px;

      img {
        width: 97px;
        height: 71px;
      }
    }

    .site-header-primary-section-right {
      padding-right: 10px;

      .ast-builder-menu {
        display: none;

        span {
          font-size: 14px;
          padding: 0 8px;
          color: #54595F;
          cursor: pointer;
        }
      }
    }
  }
}

@media only screen and (min-width: 920px) {
  .ast-desktop-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: -20px;

    .site-header-primary-section-left {
      padding-left: 35px;

      img {
        width: 193px;
        height: 142px;
      }
    }

    .site-header-primary-section-right {
      padding-right: 35px;

      .iconfont {
        display: none;
      }

      .ast-builder-menu {
        display: flex;
        background-color: none;

        span {
          font-size: 18px;
          padding: 0 16px;
          color: #54595F;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
